<template>
	<div class="message-toasts">
		<div v-for="(toast, index) in toasts" class="toast" :data-type="toast.type?.toLowerCase()" :key="index">
			<div class="icon-wrap">
				<span v-if="toast.type === 'Success'" class="icon fastic-check" data-color="white"></span>
				<span v-if="toast.type === 'Warning' || toast.type === 'Error'" class="icon fastic-alert" data-color="white"></span>
			</div>
			<div class="message">{{ toast.message }} <span @click="dismissToast(toast)" class="icon fastic-close"></span></div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";
import { useStore } from "vuex";

const store = useStore();

const toasts = computed(() => store.getters["accountAreaToastStore/toasts"]);

onMounted(() => {
	(<any>store).subscribeAction((action: any, state: any) => {
		if (action.type === "accountAreaToastStore/onAddToast") {
			addToast(action.payload);
		}
	});
});

function addToast(toast: any) {
	if (toasts.value.length <= 1) {
		toast.id = new Date().valueOf();
		toasts.value.push(toast);
		store.commit("accountAreaToastStore/setToasts", toasts.value);

		setTimeout(() => {
			dismissToast(toast);
		}, 6 * 1000, toast);
	}
}

function dismissToast(toast: any) {
	for (let i = 0; i < toasts.value.length; i++) {
		if (toasts.value[i].id === toast.id) {
			toasts.value.splice(i, 1);
			store.commit("accountAreaToastStore/setToasts", toasts.value);
			break;
		}
	}
}
</script>